import React, { useState } from "react";
import { splitDateSlash } from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../Common/LoaderForSearch";

function MarginTable(props) {
  let gridVal = props.gridVal;
  const handleScroll = props.handleScroll;
  const scrollLoader = props.scrollLoader;

  const showmargingTableData = (gridVal) => {
    return (
      gridVal &&
      gridVal.map((item, key) => {
        return (
          <tr key={key}>
            <td>
              {splitDateSlash(item?.tradeDate) === "" || undefined || null ? "-" : splitDateSlash(item?.tradeDate)}
            </td>
            <td>
              {item?.clientCode === "" || undefined || null
                ? "-"
                : item?.clientCode}
            </td>
            <td>
              {item?.clientName === "" || undefined || null
                ? "-"
                : item?.clientName}
            </td>
            <td>
              {item?.initialMargin === "" || undefined || null
                ? "-"
                : item?.initialMargin}
            </td>
            <td>
              {item?.extreamLossMargin === "" || undefined || null ? "-" : item?.extreamLossMargin}
            </td>
            <td>
              {item?.mtmMargin === "" || undefined || null ? "-" : item?.mtmMargin}
            </td>
            <td>
              {item?.finalSettlementMargin === "" || undefined || null ? "-" : item?.finalSettlementMargin}
            </td>
            <td>
              {item?.additionalMargin === "" || undefined || null ? "-" : item?.additionalMargin}
            </td>
            <td>
              {item?.totalMarginAmount === "" || undefined || null ? "-" : item?.totalMarginAmount}
            </td>
            <td>
              {item?.peakMarginAmount === "" || undefined || null ? "-" : item?.peakMarginAmount}
            </td>
            <td>
              {item?.totalMarginReportedByMember === "" || undefined || null ? "-" : item?.totalMarginReportedByMember}
            </td>
            <td>
              {item?.peakMarginReportedByMember === "" || undefined || null ? "-" : item?.peakMarginReportedByMember}
            </td>
            <td>
              {item?.eodShortfall === "" || undefined || null ? "-" : item?.eodShortfall}
            </td>
            <td>
              {item?.peakShortfall === "" || undefined || null ? "-" : item?.peakShortfall}
            </td>
            <td>
              {item?.branchCode === "" || undefined || null ? "-" : item?.branchCode}
            </td>
            <td>
              {item?.segment === "" || undefined || null ? "-" : item?.segment}
            </td>
            <td>
              {item?.rmName === "" || undefined || null ? "-" : item?.rmName}
            </td>
            <td>
              {item?.rmEmail === "" || undefined || null ? "-" : item?.rmEmail}
            </td>
          </tr>
        );
      })
    );
  };
  
  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper ">
        {gridVal && gridVal ? (
          <table className="table last-column">
            <thead>
              <tr>
                <th scope="col" className="text-center">
                  {Constants.Trade_Date}
                </th>
                <th scope="col">{Constants.Client_Code}</th>

                <th scope="col" className="text-center">
                  {Constants.client_Name}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Initial_Margin}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Extreme_Loss}
                </th>
                <th scope="col" className="text-center">
                  {Constants.MTM_Margin}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Final_Settlement}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Additional_Margin}
                </th>
                <th scope="col" className="text-center">
                  {Constants.EOD_Total_Margin}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Peak_Margin}
                </th>
                <th scope="col" className="text-center">
                  {Constants.EOD_Total_Margin_Member}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Peak_Margin_Member}
                </th>
                <th scope="col" className="text-center">
                  {Constants.EOD_Shortfall}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Peak_Shortfall}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Branche_Code}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Segment}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Rm_Name}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Rm_Email}
                </th>
              </tr>
            </thead>
            <tbody id="margin-scroll" onScroll={handleScroll}>
              {showmargingTableData(gridVal)}
              {scrollLoader && (
                <div className="loader-center">
                  <LoaderForSearch />
                </div>
              )}
            </tbody>
          </table>
        ) : (
          ""
          // <div className="report-error-message">{props.elseError}</div>
        )}
      </div>
    </>
  );
}
export default MarginTable;
